import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { CHAT } from '@constants/routes';

const Chat = lazy(() => import('@features/chat/pages/chat/Chat'));

export const ChatRoutes: RouteObject[] = [
  {
    path: CHAT.CHAT,
    element: <Chat />
  },
  {
    path: CHAT.CHAT_WITH_CONTACT,
    element: <Chat />
  }
];

export default ChatRoutes;
